/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Camera_Location_DescInputs */

const vi_camera_location_desc = /** @type {(inputs: Camera_Location_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chọn vùng trồng đặt camera "${i?.name}". Mỗi camera chỉ ở một vùng.`)
};

/**

* @param {Camera_Location_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_desc = /** @type {((inputs: Camera_Location_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_DescInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_desc(inputs)
});